<template>
  <div>
    <ManagementPage :pageName="$tc('Account', 2) + ' / ' + $tc('Company', 2)">
      <template v-slot:left>
        <TableView
          :selectedObjectID="selectedCompany ? selectedCompany.id : null"
          @change-tab="changeTab($event)"
          @open-create-company-form="selectedCompany = {}"
          @clear-selected-item="selectedCompany = null"
        />
      </template>

      <template v-slot:right>
        <company
          :selectedCompany="selectedCompany"
          @clear-selected-item="selectedCompany = null"
        />
      </template>
    </ManagementPage>
    <dialog-choice :isOpen="discardChangesDialogIsOpen" :title="$t('DiscardChanges')"
          :content="$t('ClusterCreationConfirmation')" :mainActionLabel="$t('Confirm')" @mainAction="confirmDiscardChanges"
          :secondaryActionLabel="$t('Cancel')" @secondaryAction="discardChangesDialogIsOpen = false" icon="mdi-delete"
          iconColor="#29BDF0" />
  </div>
</template>

<script>
import ManagementPage from "@/newComponents/_Organisms/ManagementPage.vue";
import TableView from "@/newComponents/SystemManagement/Companies/TableView.vue"
import Company from "@/newComponents/SystemManagement/Companies/Company.vue";
import { mapActions } from "vuex";
import { bus } from "@/main.js";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import DialogChoice from "@/newComponents/_Molecules/DialogChoice.vue";

export default {
  name: "CompaniesView",

  props: ["pageName", "menu"],

  components: {
    ManagementPage,
    TableView,
    Company,
    DialogChoice,
  },

  mixins: [checkPermissionsMixin],

  data() {
    return {
      search: "",
      selectedCompany: null,
      activeTabCompanyType: null,
      userIsCreatingOrEditingData: false,
      discardChangesDialogIsOpen: false,
      tempData: null,
    }
  },

  mounted() {
    bus.$on("toggle-create-edit-flag", () => this.userIsCreatingOrEditingData = !this.userIsCreatingOrEditingData)
    bus.$on('on-row-click', data => {
      if(this.userIsCreatingOrEditingData){
        this.tempData = _.cloneDeep(data);
        this.discardChangesDialogIsOpen = true;
      } else {
          this.selectedCompany = !!this.selectedCompany && data.id === this.selectedCompany.id ? null : _.cloneDeep(data);
        }
    });
  },

  destroyed() {
    bus.$off('on-row-click');
    bus.$off("toggle-create-edit-flag");
  },

  methods: {
    ...mapActions(["GET_ALL_LISTS"]),

    changeTab(tab) {
      this.activeTabCompanyType = tab;
      this.selectedCompany = null;
    },

    confirmDiscardChanges() {
        this.discardChangesDialogIsOpen = false;
        this.selectedCompany = !!this.selectedCompany && this.tempData.id === this.selectedCompany.id ? null : _.cloneDeep(this.tempData);
        this.tempData = null;
      },
  },
};
</script>

<style scoped>
.main-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: #fafbfc;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.searchContainer {
  display: flex;
  align-items: center;
}

.temporatyLeft {
  width: 66%;
  height: 100%;
}

.tabs-custom {
  display: flex;
  flex-direction: column;
  justify-content: flex-start !important;
}

.span-custom {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 4px 20px 4px 20px;
  color: #767676;
  font-family: Lato;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.9375rem; /* 150% */
}

.buttons-container-custom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.cancel-button-custom {
  background: transparent;
  border-radius: 0.25rem;
  border: 0.609px solid #29bdf0;
}
.leftCardContainer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 3.25104px 3.25104px 0px rgba(0, 0, 0, 0.25);
  padding: 20px 28px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 3px;
}

.leftTitle {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px; /* 200% */
  text-transform: uppercase;
}

.rightSideTitleActions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.layer-search {
  flex: 0 0 auto;
  font-size: 12px;
  margin-right: 5px;
}

.layers-search .v-input__slot {
  min-height: 0 !important;
}

.layers-search .v-label {
  top: 4px !important;
  font: normal normal normal 12px/16px Segoe UI;
  color: #b1b6b9;
}
</style>



// WEBPACK FOOTER //
// src/views/CompaniesView.vue